import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/alerts")({
  component: lazyRouteComponent(() => import("./-pages/admin.alerts")),
  head: () => ({
    meta: [
      { title: "تنبيهات الأدمن · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
